// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header_1j-hx","logo":"Header_logo_YR315","version":"Header_version_k0P6z","accountSection":"Header_accountSection_47LRE"};